import {
    setCalendarIntegrationsQuery,
    useBookableResourcesQuery,
} from '../../lib/Queries';
import useDelete from '../../lib/useDelete.jsx';
import TrashIcon from '../icons/TrashIcon.jsx';
import BookableResourceSyncing from './BookableResourceSyncing.jsx';
import { TypeToIcon } from '../../lib/CalendarSyncing.jsx';
import OptionToggle from '~/components/OptionToggle.jsx';
import useBusinessPostApi from '../../lib/useBusinessPostApi.js';
import { Cog6ToothIcon } from '@heroicons/react/24/outline';
import { useState } from 'react';
import Modal from '~/components/Modal';

const CalendarSyncingResourceSetup = ({ accounts, bookableResources, showSyncedCalendarDetails, hasMultipleUsers }) => {
    const [isSettingsOpen, setIsSettingsOpen] = useState(false);
    const [localShowDetails, setLocalShowDetails] = useState(!!showSyncedCalendarDetails);
    const { save, isSaving } = useBusinessPostApi(`/integrations/calendars/settings`);

    function openSettings() {
        setLocalShowDetails(!!showSyncedCalendarDetails);
        setIsSettingsOpen(true);
    }

    function saveSettings() {
        save({ showSyncedCalendarDetails: localShowDetails }).then(result => {
            setCalendarIntegrationsQuery(result);
            setIsSettingsOpen(false);
        });
    }

    return (
        <div>
            {accounts.length > 0 && (
                <>
                    <div className="panel-label flex items-center justify-between max-w-2xl pr-6">
                        <span>Configure Syncing</span>
                        {hasMultipleUsers && (
                            <button
                                type="button"
                                className="text-gray-500 hover:text-gray-600 w-5 h-5"
                                onClick={openSettings}
                                title="Syncing Settings"
                            >
                                <Cog6ToothIcon />
                            </button>
                        )}
                    </div>
                    {bookableResources &&
                        bookableResources.map &&
                        bookableResources.map(resource => (
                            <BookableResourceSyncing
                                key={resource.id}
                                resource={resource}
                                accounts={accounts}
                            />
                        ))}
                </>
            )}

            <Modal isOpen={isSettingsOpen} onClose={() => setIsSettingsOpen(false)}>
                <h2>Syncing Settings</h2>
                <OptionToggle
                    value={localShowDetails}
                    onChange={setLocalShowDetails}
                    toggleFirst={true}
                    title="Show synced calendar details to other users"
                    description="When enabled, other users on your team can see the titles of events from your synced calendars"
                    className="mt-4"
                />
                <div className="flex items-center gap-3 mt-6">
                    <button
                        type="button"
                        className="btn-save"
                        onClick={saveSettings}
                    >
                        {isSaving ? 'Saving...' : 'Save'}
                    </button>
                    <button
                        type="button"
                        className="btn-light-pill-lg"
                        onClick={() => setIsSettingsOpen(false)}
                    >
                        Cancel
                    </button>
                </div>
            </Modal>
        </div>
    );
};

export default CalendarSyncingResourceSetup;
